module.exports = __webpack_public_path__ + "img/ep-C.13a5e19e.jpg";